import * as React from "react";
const SvgIcFileFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.5 8.5L14 1V8.5H21.5ZM12 1H4V23H22V10.5H12V1Z" fill="currentColor" /></svg>;
export default SvgIcFileFilled;